// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603241249/js/" + chunkId + "." + {"44":"0ab6eaec","225":"e988ca12","481":"b8239d22","486":"ab8247eb","770":"3cc49c03"}[chunkId] + ".0.3144923999820737.chunk.js";
};